// Necessary if using App Router to ensure this file runs on the client
"use client";
import useUserStore from "../lib/Store/useUserStore";

import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { useEffect } from "react";

datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    forwardErrorsToLogs: true,
    service: "box-website",
    env: "production",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
});

datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    forwardErrorsToLogs: true,
    forwardConsoleLogs: "all",
    sessionSampleRate: 100,
    service: "box-website",
    env: "production",
});

export default function DatadogInit() {
    const { userData } = useUserStore();

    useEffect(() => {
        if (userData) {
            datadogRum.setUser({
                id: userData.id,
                email: userData.email,
                name: userData.name,
                paymentStatus: userData?.payment_status,
                submittedSurvey: userData?.submitted_survey,
                survey_type_taken: userData?.survey_type_taken,
            });
        }
    }, [userData]);

    return null;
}
